export default {
  title: "Branch Rating",
  headerReview: {
    title: "Leave a review",
    text: "Tell us about your impressions"
  },
  headerPlatforms: {
    title: "Thank you for the rating!",
    text: "We would be happy if you leave a review\non one of the platforms:"
  },
  headerFeedback: {
    title: "Thank you for the rating!",
    text: "Your opinion is important to us. We have already started looking into the situation you described."
  },
  feedbackForm: {
    text: "Tell us what can be improved?",
    placeholder: "Comment",
    errorMessage: "Please fill in the field",
    checkboxText: "I want to get feedback on my review",
    checkboxSubtext: "Your review will remain anonymous if you leave this field unchecked.",
    namePlaceholder: "Your name",
    contactError: "Check your name (min. 2 characters) and phone number"
  },
  submitButton: "Send",
  alert: {
    selectRating: "Please select a rating",
    branchId: "Branch ID not found"
  }
};
